<template>
  <div id="app" class="lAndG" :class="{initMsgOpen: isinitialMessageOpen}">
    <InitialMessage/>
    <Sidebar />
    <Filters />
    <Map />
  </div>
</template>

<script>
import analytics from '@/helpers/analytics';
import Map from '@/components/Map.vue';
import Filters from '@/components/Filters.vue';
import Sidebar from '@/components/Sidebar.vue';
import InitialMessage from '@/components/InitialMessage.vue';

export default {
  name: 'App',
  data() {
    return {
      isinitialMessageOpen: this.$store.state.initialMessageOpen,
      mapWidthMiddle: null,
    };
  },
  components: {
    Filters,
    Map,
    Sidebar,
    InitialMessage,
  },
  beforeMount() {
    this.loadInitialCoords();
    this.pinPathFunc();
    this.hideFilterOnMobile();
  },
  mounted() {
    document.addEventListener('DOMContentLoaded', () => {
      analytics.send('App Loaded');
    });
  },
  methods: {
    loadInitialCoords() {
      if (window.innerWidth > 767) {
        this.mapWidthMiddle = { lat: 54.1151549, lng: -9.283519 };
      } else {
        this.mapWidthMiddle = { lat: 53.8178679, lng: -3.8123276 };
      }
      this.$store.commit('initialCenterTo', this.mapWidthMiddle);
    },
    pinPathFunc() {
      if (process.env.NODE_ENV === 'production') {
        this.$store.commit('thePinsPath', `${process.env.BASE_URL}pins/`);
      } else {
        this.$store.commit('thePinsPath', './pins/');
      }
    },
    hideFilterOnMobile() {
      const mq = window.matchMedia('(max-width: 767px)');

      if (mq && mq.matches) {
        this.$store.commit('isMobile', true);
        this.$store.commit('filterToggled', false);
      }
    },
  },
  computed: {
    initialMessageOpen() {
      return this.$store.state.initialMessageOpen;
    },
  },
  watch: {
    initialMessageOpen(newInitMessage) {
      this.isinitialMessageOpen = newInitMessage;
    },
  },
};
</script>

<style lang="scss">
:root {
  --retirement: #0076D6;
  --housing: #E22922;
  --sme: #DD9C00;
  --future: #737373;
  --urban: #005629;
  --climate: #004E86;
  --greenUI: #008844;
  --greenUIDark: #005629;
  --greenCheckmark: #00642A;
}

@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap');
@font-face {
  font-family: 'LyonBold';
  font-style: 'normal';
  font-weight: 'normal';
  src: url(~@/assets/fonts/LyonDisplay-Bold.eot);
  src: url(~@/assets/fonts/LyonDisplay-Bold.eot?#iefix) format('embedded-opentype'),
      url(~@/assets/fonts/LyonDisplay-Bold.woff) format('woff'),
      url(~@/assets/fonts/LyonDisplay-Bold.svg#LyonDisplay-Bold) format('svg'),
      url(~@/assets/fonts/LyonDisplay-Bold.ttf) format('truetype');
}
html, body {
  margin: 0; padding: 0;
}
#app.lAndG {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #111;
  background-color: #fff;
  position: relative;
  overflow: hidden;
}
.initMsgOpen {
  .filtersOverall, .exploreTheMapMsg, .mapLogo {
    display: none;
  }
}
// to overwrite tcuk styles
*, *:before, *:after {
    box-sizing: initial;
}
img {
    max-width: initial;
}
img {
    vertical-align: initial;
}
.html-embed.component {margin-bottom: 0 !important}
</style>
